/*
 * HomeReducer
 *
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 */

import produce from 'immer';
import { ON_PROGRESS_DATA,ON_NOTIFY, LOADER_STATUS,SET_TOTAL_RECORD,
   PROFILE_INFO,SET_GSTR3B_SUMMARY,SET_GSTR3B_FILE_DATA,SET_GSTR3B_FILE_DATA_MASTER,
   SET_HISTORY_DATA,
   TOTAL_RECORD
  } from './constants';

// The initial state of the App
export const initialState = {
  progressData: [],
  loaderStatus: false,
  totalRecord:'',
  profileData:[],
  summary:{},
  gstr3bFileData:[],
  masterData:[],
  status: false,
  msg: '',
  totalRecords: '',
  records: '',
  historyTableData:[],
};

/* eslint-disable default-case, no-param-reassign */
const SavePageGSTR3BReducer = (state = initialState, action) =>{
    switch (action.type) {
      case ON_PROGRESS_DATA:
        return {
          ...state,
          progressData:action.progressData
        }
        case SET_HISTORY_DATA:
          return {
            ...state,
            historyTableData:action.historyTableData
          }
          case TOTAL_RECORD:
            return {
              ...state,
              totalRecords:action.totalRecords,
              records:action.records
            }
        case ON_NOTIFY:
          return {
            ...state,
            status:action.status,
            msg:action.msg
          }
      case LOADER_STATUS:
        return {
          ...state,
          loaderStatus:action.loaderStatus
        }
      case SET_TOTAL_RECORD:
        return {
          ...state,
          totalRecord:action.totalRecord
        }
      case PROFILE_INFO:
        return {
          ...state,
          profileData:action.profileData
        }
      case SET_GSTR3B_SUMMARY:
        return {
          ...state,
          summary:action.gstr3bSummary
        }
      case SET_GSTR3B_FILE_DATA:
        return {
          ...state,
          gstr3bFileData:action.gstr3bFileData
        }
      case SET_GSTR3B_FILE_DATA_MASTER:
        return {
          ...state,
          masterData:action.fileDataMaster
        }
      default:
        return state;
    }
  };

export default SavePageGSTR3BReducer;
